import axios from "axios";
import authHeader from "./auth-header";

axios.defaults.withCredentials = true;


const API_URL = process.env.REACT_APP_API_URL;
// A4 – Basis-URL der Auth-Endpunkte (inkl. 2FA): .../api/auth/
const AUTH_URL = process.env.REACT_APP_AUTH_API_URL;

// A4 – Zwei-Faktor-Authentifizierung (TOTP).
const get2faStatus = () => {
  return axios.get(AUTH_URL + "2fa/status", { headers: authHeader() });
};
const setup2fa = () => {
  return axios.post(AUTH_URL + "2fa/setup", {}, { headers: authHeader() });
};
const confirm2fa = (token) => {
  return axios.post(AUTH_URL + "2fa/confirm", { token }, { headers: authHeader() });
};
const disable2fa = (payload) => {
  return axios.post(AUTH_URL + "2fa/disable", payload || {}, { headers: authHeader() });
};

// A5 – tokenbasierte "Passwort festlegen"/Passwort-vergessen-Funktion.
// Oeffentliche Endpunkte (ohne Anmeldung), daher ohne authHeader.
const requestPasswordReset = (email) => {
  return axios.post(AUTH_URL + "password/request", { email });
};
const setPasswordWithToken = (token, password) => {
  return axios.post(AUTH_URL + "password/set", { token, password });
};

const getPublicContent = () => {
  return axios.get(API_URL + "all");
};

const getUserBoard = () => {
  return axios.get(API_URL + "user", { headers: authHeader() });
};

const getModeratorBoard = () => {
  return axios.get(API_URL + "mod", { headers: authHeader() });
};

const getAdminBoard = () => {
  return axios.get(API_URL + "admin", { headers: authHeader() });
};

const getTaxesBoard = () => {
  return axios.get(API_URL + "taxes", { headers: authHeader() });
};

const deleteTaxesBoard = (id) => {
  return axios.delete(API_URL + "taxes/"+id, { headers: authHeader() });
};

const updateTaxesBoard = (id,formData) => {
  return axios.put(API_URL + "taxes/"+id,formData ,{ headers: authHeader() });
};

const createTaxesBoard = (formData) => {
  return axios.post(API_URL + "taxes",formData ,{ headers: authHeader() });
};


const getMainVosBoard = () => {
  return axios.get(API_URL + "mainvos", { headers: authHeader() });
};

const deleteMainVosBoard = (id) => {
  return axios.delete(API_URL + "mainvos/"+id, { headers: authHeader() });
};

const updateMainVosBoard = (id,formData) => {
  return axios.put(API_URL + "mainvos/"+id,formData ,{ headers: authHeader() });
};

const createMainVosBoard = (formData) => {
  return axios.post(API_URL + "mainvos",formData ,{ headers: authHeader() });
};


const getSubVosBoard = () => {
  return axios.get(API_URL + "subvos", { headers: authHeader() });
};

const deleteSubVosBoard = (id) => {
  return axios.delete(API_URL + "subvos/"+id, { headers: authHeader() });
};

const updateSubVosBoard = (id,formData) => {
  return axios.put(API_URL + "subvos/"+id,formData ,{ headers: authHeader() });
};

const createSubVosBoard = (formData) => {
  return axios.post(API_URL + "subvos",formData ,{ headers: authHeader() });
};

// --- START NEUER CODE ---

const getMainVoById = (id) => {
  return axios.get(API_URL + `mainvos/${id}`, { headers: authHeader() });
};

const getSubVoById = (id) => {
  return axios.get(API_URL + `subvos/${id}`, { headers: authHeader() });
};

// Annahme basierend auf getAdById in der Datei
const getAdmById = (id) => {
  return axios.get(API_URL + `adm/${id}`, { headers: authHeader() });
};

// --- ENDE NEUER CODE ---



const getCustomersADM = () => {
  return axios.get(API_URL + "customeradm", { headers: authHeader() });
};
const getCustomerBoard = () => {
  return axios.get(API_URL + "customer", { headers: authHeader() });
};

const deleteCustomerBoard = (id) => {
  return axios.delete(API_URL + "customer/"+id, { headers: authHeader() });
};

const updateCustomerBoard = (id,formData) => {
  return axios.put(API_URL + "customer/"+id,formData ,{ headers: authHeader() });
};
const changeMyPasswordBoard = (formData) => {
  return axios.put(API_URL + "changePassword",formData ,{ headers: authHeader() });
};

const changeMyPasswordBoardADM = (formData) => {
  return axios.put(API_URL + "changePassword/adm",formData ,{ headers: authHeader() });
};


const changeMyPasswordEmployeeBoard = (formData) => {
  return axios.put(API_URL + "changeEmployeePassword",formData ,{ headers: authHeader() });
};



const createCustomerBoard = (formData) => {
  return axios.post(API_URL + "customer",formData ,{ headers: authHeader() });
};




const getCustomerEmployeesBoard = (extId) => {
  return axios.get(API_URL + "employeecustomer/"+extId, { headers: authHeader() });
};
const getCustomerMeBoard = (extId) => {
  return axios.get(API_URL + "customerme/"+extId, { headers: authHeader() });
};

const getEmployiesBoard = () => {
  return axios.get(API_URL + "employee", { headers: authHeader() });
};

const getSingleEmployeeBoard = () => {
  return axios.get(API_URL + "singleemployee", { headers: authHeader() });
};

const deleteEmployiesBoard = (id) => {
  return axios.delete(API_URL + "employee/"+id, { headers: authHeader() });
};

const updateEmployiesBoard = (id,formData) => {
  return axios.put(API_URL + "employee/"+id,formData ,{ headers: authHeader() });
};

const createEmployiesBoard = (formData) => {
  return axios.post(API_URL + "employee",formData ,{ headers: authHeader() });
};


const getAreaGroupBoard = () => {
  return axios.get(API_URL + "areagroups", { headers: authHeader() });
};

const deleteAreaGroupBoard = (id) => {
  return axios.delete(API_URL + "areagroups/"+id, { headers: authHeader() });
};

const updateAreaGroupBoard = (id,formData) => {
  return axios.put(API_URL + "areagroups/"+id,formData ,{ headers: authHeader() });
};

const createAreaGroupBoard = (formData) => {
  return axios.post(API_URL + "areagroups",formData ,{ headers: authHeader() });
};

const getAreaBoard = () => {
  return axios.get(API_URL + "areasgroup", { headers: authHeader() });
};
const getAreaBoard2 = () => {
  return axios.get(API_URL + "areasgroupg", { headers: authHeader() });
};

const deleteAreaBoard = (id) => {
  return axios.delete(API_URL + "areas/"+id, { headers: authHeader() });
};

const updateAreaBoard = (id,formData) => {
  return axios.put(API_URL + "areas/"+id,formData ,{ headers: authHeader() });
};

const createAreaBoard = (formData) => {
  return axios.post(API_URL + "areas",formData ,{ headers: authHeader() });
};

const getCountryBoard = () => {
  return axios.get(API_URL + "countries", { headers: authHeader() });
};

const deleteCountryBoard = (id) => {
  return axios.delete(API_URL + "countries/"+id, { headers: authHeader() });
};

const updateCountryBoard = (id,formData) => {
  return axios.put(API_URL + "countries/"+id,formData ,{ headers: authHeader() });
};

const createCountryBoard = (formData) => {
  return axios.post(API_URL + "countries",formData ,{ headers: authHeader() });
};

const getCurrencyBoard = () => {
  return axios.get(API_URL + "currencies", { headers: authHeader() });
};

const deleteCurrencyBoard = (id) => {
  return axios.delete(API_URL + "currencies/"+id, { headers: authHeader() });
};

const updateCurrencyBoard = (id,formData) => {
  return axios.put(API_URL + "currencies/"+id,formData ,{ headers: authHeader() });
};

const createCurrencyBoard = (formData) => {
  return axios.post(API_URL + "currencies",formData ,{ headers: authHeader() });
};

const getServiceBoard = () => {
  return axios.get(API_URL + "services", { headers: authHeader() });
};

const deleteServiceBoard = (id) => {
  return axios.delete(API_URL + "services/"+id, { headers: authHeader() });
};

const updateServiceBoard = (id,formData) => {
  return axios.put(API_URL + "services/"+id,formData ,{ headers: authHeader() });
};

const createServiceBoard = (formData) => {
  return axios.post(API_URL + "services",formData ,{ headers: authHeader() });
};

// --- Produkt-Showcase (Container/Produktarten) ---
const getShowcaseBoard = () => {
  return axios.get(API_URL + "showcase", { headers: authHeader() });
};

const createShowcase = (formData) => {
  return axios.post(API_URL + "showcase", formData, { headers: authHeader() });
};

const updateShowcase = (id, formData) => {
  return axios.put(API_URL + "showcase/" + id, formData, { headers: authHeader() });
};

const deleteShowcase = (id) => {
  return axios.delete(API_URL + "showcase/" + id, { headers: authHeader() });
};

// --- API-Registry (API-Administration) ---
const getApiRegistry = () => {
  return axios.get(API_URL + "api-registry", { headers: authHeader() });
};

const createApiRegistry = (formData) => {
  return axios.post(API_URL + "api-registry", formData, { headers: authHeader() });
};

const updateApiRegistry = (id, formData) => {
  return axios.put(API_URL + "api-registry/" + id, formData, { headers: authHeader() });
};

const deleteApiRegistry = (id) => {
  return axios.delete(API_URL + "api-registry/" + id, { headers: authHeader() });
};

// Verbindungstest (Handshake) zur Partner-API.
const testApiRegistry = (id) => {
  return axios.post(API_URL + "api-registry/" + id + "/handshake", {}, { headers: authHeader() });
};

// Module/Parameter einer API laden (fuer Tarif-Modulauswahl).
const getApiParameters = (id) => {
  return axios.get(API_URL + "api-registry/" + id + "/parameters", { headers: authHeader() });
};

const getStatusBoard = () => {
  return axios.get(API_URL + "statuses", { headers: authHeader() });
};

const deleteStatusBoard = (id) => {
  return axios.delete(API_URL + "statuses/"+id, { headers: authHeader() });
};

const updateStatusBoard = (id,formData) => {
  return axios.put(API_URL + "statuses/"+id,formData ,{ headers: authHeader() });
};

const createStatusBoard = (formData) => {
  return axios.post(API_URL + "statuses",formData ,{ headers: authHeader() });
};

/**
 * Oeffentliches Selbstbucher-Angebot (ohne Anmeldung lesbar). Liefert, ob die
 * Funktion aktiv ist, welcher Haupt-VO Eigentuemer ist und welche Dienste
 * digital buchbar sind.
 */
const getSelfServiceOffer = () => {
  return axios.get(API_URL + "public/selfservice/offer");
};

/** Oeffentliche Kartenpunkte aktiv gestellter Kunden (ohne Anmeldung lesbar). */
const getSelfServiceMapEntries = () => {
  return axios.get(API_URL + "public/selfservice/map");
};

/**
 * Oeffentlicher Katalog der buchbaren Chargen. Tarif und Dienst sind bereits
 * bei der Chargen-Anlage festgelegt und werden hier nur angezeigt.
 */
const getSelfServiceCatalog = () => {
  return axios.get(API_URL + "public/selfservice/catalog");
};

/** A3 – ALTCHA Proof-of-Work-Challenge fuer den Bot-Schutz der Selbstbuchung. */
const getSelfServiceAltchaChallenge = () => {
  return axios.get(API_URL + "public/selfservice/altcha-challenge");
};

/** Selbstregistrierung mit sofortiger QR-Code-Buchung (ohne Anmeldung). */
const registerSelfService = (formData) => {
  return axios.post(API_URL + "public/selfservice/register", formData);
};

const createSelfServiceTrial = (formData) => {
  return axios.post(API_URL + "public/selfservice/trial", formData);
};

/** Liste "Gerade erzeugt" seitenweise; ohne Parameter liefert sie Seite 1. */
const getSelfServiceLive = (params) => {
  return axios.get(API_URL + "public/selfservice/live", params ? { params } : undefined);
};

/** Neue QR-Weiterleitungen fuer die Sternschnuppen der Live-Karte. */
const getSelfServiceMapFlights = (since) => {
  return axios.get(API_URL + "public/selfservice/map/flights", {
    params: since === undefined || since === null ? {} : { since },
  });
};

const confirmSelfServiceEmail = (token) => {
  return axios.post(API_URL + "public/selfservice/confirm-email", { token });
};

const resendSelfServiceConfirmation = (email) => {
  return axios.post(API_URL + "public/selfservice/resend-confirmation", { email });
};

const getSelfServiceProfile = () => {
  return axios.get(API_URL + "selfservice/profile", { headers: authHeader() });
};

const updateSelfServiceProfile = (formData) => {
  return axios.put(API_URL + "selfservice/profile", formData, { headers: authHeader() });
};

const getPublicBusinessDetail = (identifier) => {
  return axios.get(API_URL + "public/selfservice/business/" + encodeURIComponent(identifier));
};

const getPromo = (placeId) => {
  return axios.get(API_URL + "selfservice/promo/" + encodeURIComponent(placeId), { headers: authHeader() });
};

const updatePromo = (placeId, data) => {
  return axios.put(API_URL + "selfservice/promo/" + encodeURIComponent(placeId), data, { headers: authHeader() });
};

const uploadPromoFlyer = (placeId, formData) => {
  return axios.post(
    API_URL + "selfservice/promo/" + encodeURIComponent(placeId) + "/flyer",
    formData,
    { headers: { ...authHeader(), "Content-Type": "multipart/form-data" } }
  );
};

const deletePromoFlyer = (placeId) => {
  return axios.delete(API_URL + "selfservice/promo/" + encodeURIComponent(placeId) + "/flyer", { headers: authHeader() });
};

/** Stammdaten "Transportarten" (Auslieferungswege eines Dienstes). */
const getTransportTypesBoard = () => {
  return axios.get(API_URL + "transport-types", { headers: authHeader() });
};

const deleteTransportTypeBoard = (id) => {
  return axios.delete(API_URL + "transport-types/" + id, { headers: authHeader() });
};

const updateTransportTypeBoard = (id, formData) => {
  return axios.put(API_URL + "transport-types/" + id, formData, { headers: authHeader() });
};

const createTransportTypeBoard = (formData) => {
  return axios.post(API_URL + "transport-types", formData, { headers: authHeader() });
};

/** Stammdaten "Startguthabenarten" (z. B. EUR, Minuten, TOKEN). */
const getStartCreditTypesBoard = () => {
  return axios.get(API_URL + "start-credit-types", { headers: authHeader() });
};

const deleteStartCreditTypeBoard = (id) => {
  return axios.delete(API_URL + "start-credit-types/" + id, { headers: authHeader() });
};

const updateStartCreditTypeBoard = (id, formData) => {
  return axios.put(API_URL + "start-credit-types/" + id, formData, { headers: authHeader() });
};

const createStartCreditTypeBoard = (formData) => {
  return axios.post(API_URL + "start-credit-types", formData, { headers: authHeader() });
};

const getPlacesBoard = () => {
  return axios.get(API_URL + "place", { headers: authHeader() });
};

const getPlacesBoardWB = () => {
  return axios.get(API_URL + "places", { headers: authHeader() });
};

const deletePlacesBoard = (id) => {
  return axios.delete(API_URL + "place/"+id, { headers: authHeader() });
};

const updatePlacesBoard = (id,formData) => {
  return axios.put(API_URL + "place/"+id,formData ,{ headers: authHeader() });
};

const createPlacesBoard = (formData) => {
  return axios.post(API_URL + "place",formData ,{ headers: authHeader() });
};

const getTariffBoard = () => {
  // Vollstaendige Liste anfordern (Pagination erfolgt clientseitig in der UI).
  return axios.get(API_URL + "tariffs?page=1&limit=1000", { headers: authHeader() });
};

// Vorlagen der uebergeordneten Stufe zum Klonen im Tarif-Erstellen-Modal.
const getParentTariffTemplates = () => {
  return axios.get(API_URL + "tariffs/parent-templates", { headers: authHeader() });
};

const getTariffBoardADM = () => {
  return axios.get(API_URL + "tariffsadm?page=1&limit=1000", { headers: authHeader() });
};

// --- START NEUER CODE ---
const getTariffById = (tariff_id) => {
  return axios.get(API_URL + `tariffs/${tariff_id}`, { headers: authHeader() });
};
// --- ENDE NEUER CODE ---


const deleteTariffBoard = (id) => {
  return axios.delete(API_URL + "tariffs/"+id, { headers: authHeader() });
};

const updateTariffBoard = (id,formData) => {
  return axios.put(API_URL + "tariffs/"+id,formData ,{ headers: authHeader() });
};

const createTariffBoard = (formData) => {
  return axios.post(API_URL + "tariffs",formData ,{ headers: authHeader() });
};

/** qutel-Stammdaten (Reseller, Zonen, Rates, SIP-Typen, Payment-Typen). */
const getQutelMasterdata = () => {
  return axios.get(API_URL + "qutel/masterdata", { headers: authHeader() });
};

const getRolesBoard = () => {
  return axios.get(API_URL + "roles", { headers: authHeader() });
};

const deleteRolesBoard = (id) => {
  return axios.delete(API_URL + "roles/"+id, { headers: authHeader() });
};

const updateRolesBoard = (id,formData) => {
  return axios.put(API_URL + "roles/"+id,formData ,{ headers: authHeader() });
};

const createRolesBoard = (formData) => {
  return axios.post(API_URL + "roles",formData ,{ headers: authHeader() });
};

const getUsersBoard = () => {
  return axios.get(API_URL + "users", { headers: authHeader() });
};

const deleteUsersBoard = (id) => {
  return axios.delete(API_URL + "users/"+id, { headers: authHeader() });
};

const updateUsersBoard = (id,roleid,formData) => {
  return axios.put(API_URL + "users/"+id+"/"+roleid,formData ,{ headers: authHeader() });
};

const createUsersBoard = (roleid,formData) => {
  return axios.post(API_URL + "users/"+roleid,formData ,{ headers: authHeader() });
};

// Sperrt (locked=true) oder entsperrt (locked=false) einen Benutzer.
const setUserLock = (id, locked) => {
  return axios.put(API_URL + "users/"+id+"/lock", { locked }, { headers: authHeader() });
};

const getDashboard = (formData) => {
  return axios.post(API_URL + "dashboard", formData,{ headers: authHeader() });
};
const getCustomerReviews = (formData) => {
  return axios.post(API_URL + "getCR", formData,{ headers: authHeader() });
};

const getEmployeeReviews = (formData) => {
  return axios.post(API_URL + "getER", formData,{ headers: authHeader() });
};

const getBatchBoard = () => {
  return axios.get(API_URL + "batches", { headers: authHeader() });
};

const deleteBatchBoard = (id) => {
  return axios.delete(API_URL + "batches/"+id, { headers: authHeader() });
};

// Aktionsbuendel: mehrere Chargencodes sperren ("block") oder loeschen ("delete").
const bulkBatchAction = (action, ids) => {
  return axios.post(
    API_URL + "batches/bulk",
    { action, ids },
    { headers: authHeader() }
  );
};

const updateBatchBoard = (id,formData) => {
  return axios.put(API_URL + "batches/"+id,formData ,{ headers: authHeader() });
};

const createBatchBoard = (formData) => {
  return axios.post(API_URL + "batches",formData ,{ headers: authHeader() });
};

const getBatchBoardMaster = (formData) => {
  return axios.post(API_URL + "getbatchesmaster",formData, { headers: authHeader() });
};
const getBatchBoardSubvos = (formData) => {
  return axios.post(API_URL + "getbatchessubvos",formData, { headers: authHeader() });
};
const rentBatchPortion = (formData) => {
  return axios.post(API_URL + "batchessubvos/ci",formData, { headers: authHeader() });
};



const deleteBatchBoardMaster = (id) => {
  return axios.delete(API_URL + "batchesmaster/"+id, { headers: authHeader() });
};

const updateBatchBoardMaster = (id,formData) => {
  return axios.put(API_URL + "batchesmaster/"+id,formData ,{ headers: authHeader() });
};

// Charge sperren/entsperren. lock = true (sperren) / false (entsperren).
const toggleBatchLock = (id, lock) => {
  return axios.put(API_URL + "batchesmaster/"+id+"/lock", { lock }, { headers: authHeader() });
};

const createBatchBoardMaster = (formData) => {
  return axios.post(API_URL + "batchesmaster",formData ,{ headers: authHeader() });
};

const getNotificationBoard = () => {
  return axios.get(API_URL + "email_notifications", { headers: authHeader() });
};

const deleteNotificationBoard = (id) => {
  return axios.delete(API_URL + "email_notifications/"+id, { headers: authHeader() });
};

const updateNotificationBoard = (id,formData) => {
  return axios.put(API_URL + "email_notifications/"+id,formData ,{ headers: authHeader() });
};

const createNotificationBoard = (formData) => {
  return axios.post(API_URL + "email_notifications",formData ,{ headers: authHeader() });
};
const sendNotificationBoardReset = (customerId) => {
  // Korrektur: Der Token muss als dritter Parameter (axios-Config) gesendet
  // werden, nicht als Request-Body. Zuvor wurde { headers } faelschlich als
  // Body uebergeben, wodurch die Authentifizierung auf den Cookie zurueckfiel.
  // Der leere Body {} bleibt erhalten; der Cookie-Fallback im Backend bleibt
  // als zusaetzliche Absicherung unveraendert bestehen.
  return axios.post(API_URL + "email_notifications/" + customerId, {}, { headers: authHeader() });
};

const sendNotificationBoard = (formData) => {
  
  return axios.post(API_URL + "email_notifications_custom",formData ,{ headers: authHeader() });
};

const getRequestData = () => {
  return axios.get(API_URL + "rq", { headers: authHeader() });
};

const deleteRequestData = (id) => {
  return axios.delete(API_URL + "rq/"+id, { headers: authHeader() });
};

const updateRequestData = (id,formData) => {
  return axios.put(API_URL + "rq/"+id,formData ,{ headers: authHeader() });
};

const createRequestData = (formData) => {
  return axios.post(API_URL + "rq",formData ,{ headers: authHeader() });
};
const employeeRequestData = (formData) => {
  return axios.post(API_URL + "getES",formData, { headers: authHeader() });
};

const customerRequestData = (formData) => {
  return axios.post(API_URL + "getCS",formData, { headers: authHeader() });
};
const customerERequestData = (formData) => {
  return axios.post(API_URL + "getCES",formData, { headers: authHeader() });
};

const createInvoice = (formData) => {
  return axios.post(API_URL + "batchesmaster/ci",formData, { headers: authHeader() });
};
const getInvoices = (formData) => {
  return axios.post(API_URL + "batchesmaster/invoices",formData, { headers: authHeader() });
};

const getInvoicesADM = (formData) => {
  return axios.post(API_URL + "adminvoicemanager/invoices",formData, { headers: authHeader() });
};
const getInvoicesSUBVO = (formData) => {
  return axios.post(API_URL + "subvoinvoicemanager/invoices",formData, { headers: authHeader() });
};

// Funktion für Subvo, um seine EINGANGSRECHNUNGEN vom Mainvo zu erhalten
const getIncomingInvoicesForSubvo = (params) => {
  // Dies ist die korrekte URL aus Ihrer invoice.routes.js
  return axios.post(API_URL + "subvo/invoices/incoming", params, { headers: authHeader() });
};

// Passende Download-Funktion für die Eingangsrechnungen
const downloadIncomingInvoiceForSubvo = (id) => {
    // Dies ist die korrekte URL aus Ihrer invoice.routes.js
    return axios.get(API_URL + `subvo/invoices/incoming/${id}/pdf`, {
        headers: authHeader(),
        responseType: "blob",
    });
};

const getInvoicesCustomer = (formData) => {
  return axios.post(API_URL + "customerinvoicemanager/invoices",formData, { headers: authHeader() });
};


const revertRenting = (formData) => {
  return axios.post(API_URL + "batchesmaster/revert",formData, { headers: authHeader() });
};

const cancelInvoice = (id) => {
  // axios.put(url, data, config): Token muss in der Config (3. Argument) stehen,
  // sonst wird { headers } faelschlich als Body gesendet und kein Token uebertragen.
  return axios.put(API_URL + "batchesmaster/invoices/"+id, null, { headers: authHeader() });
};
const cancelBatchOrders = (orders) => {
  return axios.put(API_URL + "cancelbatchesorder/",orders, { headers: authHeader() });
};


const markInvoiceAsPaid = (id) => {
  // axios.put(url, data, config): Token in der Config (3. Argument) uebergeben.
  return axios.put(API_URL + "batchesmaster/invoices/"+id+"/pay", null, { headers: authHeader() });
};
const downloadInvoice = (id) => {
  return axios.get(API_URL + "batchesmaster/invoices/"+id+"/pdf", { headers: authHeader(),responseType: 'blob' });
};

// Erzeugt die PDF-Datei einer bestehenden Rechnung neu (Admin).
const generateInvoicePdf = (id) => {
  return axios.post(API_URL + "batchesmaster/invoices/"+id+"/generate-pdf", {}, { headers: authHeader() });
};

// FÜGEN SIE DIE NEUE FUNKTION HIER EIN
const deleteInvoice = (id) => {
  return axios.delete(API_URL + "invoices/" + id, { headers: authHeader() });
};

const downloadInvoiceADM = (id) => {
  return axios.get(API_URL + "adm/invoices/"+id+"/pdf", { headers: authHeader(),responseType: 'blob' });
};

const downloadInvoiceSUBVO = (id) => {
  return axios.get(API_URL + "subvo/invoices/"+id+"/pdf", { headers: authHeader(),responseType: 'blob' });
};

const downloadInvoiceCustomer = (id) => {
  return axios.get(API_URL + "customer/invoices/"+id+"/pdf", { headers: authHeader(),responseType: 'blob' });
};




// Fetch all countries with optional pagination, search, sorting
const getAllCountries = (params) => {
  const { page, search, sort, order } = params;
  return axios.get(API_URL + 'countries', {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order
    }
  });
};

// Fetch a single country by its ID
const getCountryById = (id) => {
  return axios.get(API_URL + 'countries/' + id, {
    headers: authHeader()
  });
};

// Create a new country
const createCountry = (countryData) => {
  return axios.post(API_URL + 'countries', countryData, {
    headers: authHeader()
  });
};

// Update an existing country by its ID
const updateCountry = (id, countryData) => {
  return axios.put(API_URL + 'countries/' + id, countryData, {
    headers: authHeader()
  });
};


// Update an existing country by its ID
const saveBatchCode = ( batchCodeId,formData) => {
  return axios.put(API_URL + 'batchcodes/customer/' + batchCodeId, formData, {
    headers: authHeader()
  });
};





// Delete a country by its ID
const deleteCountry = (id) => {
  return axios.delete(API_URL + 'countries/' + id, {
    headers: authHeader()
  });
};

// Example for taxes and currencies if you need similar functions
const getAllTaxes = () => {
  return axios.get(API_URL + 'taxes', {
    headers: authHeader()
  });
};

const getAllCurrencies = () => {
  return axios.get(API_URL + 'currencies', {
    headers: authHeader()
  });
};

// Fetch all ads with optional pagination, search, sorting
const getAllAds = (params) => {
  const { page, search, sort, order } = params;
  return axios.post(API_URL + 'adm/list',params, {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order
    }
  });
};



// Fetch a single ad by its ID
const getAdById = (id) => {
  return axios.get(API_URL + 'adm/' + id, {
    headers: authHeader()
  });
};

// Fetch a single ad by its ID
const getAdByIdADM = () => {
  return axios.get(API_URL + 'tadm/admsingle', {
    headers: authHeader()
  });
};




// Create a new ad
const createAd = (adData) => {
  return axios.post(API_URL + 'adm', adData, {
    headers: authHeader()
  });
};

const sellBatchCodes = (sellData) => {
  return axios.post(API_URL + 'adm/sale', sellData, {
    headers: authHeader()
  });
};

const sellDemoBatchCodes = (sellData) => {
  return axios.post(API_URL + 'adm/demosale', sellData, {
    headers: authHeader()
  });
};


const activateDemoBatchCodes = (sellData) => {
  return axios.post(API_URL + 'activate/demo', sellData, {
    headers: authHeader()
  });
};

const updateTargetPlace = (placeData) => {
  return axios.post(API_URL + 'target-place', placeData, {
    headers: authHeader()
  });
};

const cancelDemoBatchCode = (sellData) => {
  return axios.post(API_URL + 'cancel/demo', sellData, {
    headers: authHeader()
  });
};



// Update an existing ad by its ID
const updateAd = (id, adData) => {
  return axios.put(API_URL + 'adm/update/' + id, adData, {
    headers: authHeader()
  });
};

// Update an existing ad by its ID
const updateAdBoard = (adData) => {
  return axios.put(API_URL + 'tadm/update', adData, {
    headers: authHeader()
  });
};






// Delete an ad by its ID
const deleteAd = (id) => {
  return axios.delete(API_URL + 'adm/' + id, {
    headers: authHeader()
  });
};



// Fetch all ads with optional pagination, search, sorting
const getBatchOrdersADM = (params) => {
  const { page, search, sort, order } = params;
  return axios.post(API_URL + 'batchordersadmonly',params, {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order
    }
  });
};
// Fetch all ads with optional pagination, search, sorting
const getBatchOrders = (params) => {
  const { page, search, sort, order } = params;
  return axios.post(API_URL + 'batchordersadm',params, {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order
    }
  });
};

// Fetch all ads with optional pagination, search, sorting
const getADMBatchOrders = (params) => {
  const { page, search, sort, order } = params;
  return axios.post(API_URL + 'adm/batches',params, {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order
    }
  });
};

// --- START NEUER CODE ---
const getBatchOrderByBatchId = (batch_id) => {
  return axios.get(API_URL + `batch-orders/by-batch/${batch_id}`, { headers: authHeader() });
};
// --- ENDE NEUER CODE ---



// Fetch all ads with optional pagination, search, sorting
const getDemoBatchOrders = (params) => {
  const { page, search, sort, order } = params;
  return axios.post(API_URL + 'getbatches/demo',params, {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order
    }
  });
};

const lookupDemoCode = (code) => {
  return axios.post(API_URL + 'demo/lookup', { code }, {
    headers: authHeader()
  });
};


// Fetch all ads with optional pagination, search, sorting
const getAllCustomersADMP = (params) => {
  const { page, search, sort, order } = params;
  return axios.get(API_URL + 'customeradm/list', {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order
    }
  });
};

const getAllBatchCodes = (params) => {
  const { page, search, sort, order, limit } = params;
  return axios.get(API_URL + 'customerbatches', {
    headers: authHeader(),
    params: {
      page,
      search,
      sort,
      order,
      limit
    }
  });
};

const getUpgradeOffers = (batchCodeId) => {
  return axios.get(API_URL + `customerbatches/${batchCodeId}/upgrade-offers`, {
    headers: authHeader()
  });
};

const manageCustomerSubscription = (batchCodeId, payload) => {
  return axios.post(API_URL + `customerbatches/${batchCodeId}/subscription`, payload, {
    headers: authHeader()
  });
};

const bookCustomerOffer = (payload) => {
  return axios.post(API_URL + "customerbatches/book", payload, {
    headers: authHeader()
  });
};

const getMyEmployees = () => {
  
  return axios.get(API_URL + 'getEmployees/ByCustomerId', {
    headers: authHeader()
   
  });
};


// Neue Funktionen für Invoice Settings
const getInvoiceNumberSettings = (docTypeId) => {
  // Die Funktion akzeptiert nun eine Belegart-ID
  return axios.get(API_URL + "invoice-settings", { 
    headers: authHeader(),
    params: { doc_type_id: docTypeId } // und hängt sie als Parameter an die URL an
  });
};

const updateInvoiceNumberSettings = (settingsData) => {
  // settingsData muss die doc_type_id aus dem Frontend enthalten
  // Die Route wurde im Backend auf POST geändert, um das Speichern zu vereinfachen
  return axios.post(API_URL + "invoice-settings", settingsData, { headers: authHeader() });
};

// +++ ANFANG: API-FUNKTIONEN FÜR ZAHLUNGSARTEN +++
const getPaymentMethods = () => {
  return axios.get(API_URL + "payment/methods", { headers: authHeader() });
};

// NEU & KORRIGIERT: Holt Zahlungsarten für den ADM (Außendienstmitarbeiter)
const getPaymentMethodsForAdm = () => {
  return axios.get(API_URL + "adm/payment/methods", { headers: authHeader() });
};

// NEU: Holt eine einzelne Methode mit voller Konfiguration
const getPaymentMethodById = (id) => {
  return axios.get(API_URL + `payment/methods/${id}`, { headers: authHeader() });
};

const createPaymentMethod = (methodData) => {
  return axios.post(API_URL + "payment/methods", methodData, { headers: authHeader() });
};

const updatePaymentMethodStatus = (id, statusData) => {
  return axios.put(API_URL + `payment/methods/${id}/status`, statusData, { headers: authHeader() });
};

const updatePaymentMethod = (id, methodData) => {
  return axios.put(API_URL + `payment/methods/${id}`, methodData, { headers: authHeader() });
};

// KORRIGIERT: Nimmt ein Objekt als Parameter, um alle IDs zu übergeben
const createPaymentSession = (sessionData) => {
  return axios.post(API_URL + "payment/create-session", sessionData, { headers: authHeader() });
};
// +++ ENDE: API-FUNKTIONEN FÜR ZAHLUNGSARTEN +++

// NEU: Erstellt einen Payment Link
const createPaymentLink = (linkData) => {
  return axios.post(API_URL + "payment/create-payment-link", linkData, { headers: authHeader() });
};

// NEU: Fragt den Status einer Bestellung ab
const getOrderStatus = (orderId) => {
  return axios.get(API_URL + `batchesmaster/orders/${orderId}/status`, { headers: authHeader() });
};

// +++ ANFANG: API-FUNKTIONEN FÜR BELEGARTEN (Document Types) +++
// scope === 'system' adressiert die System-Vorlagen (nur fuer Admins).
const _docScopeQuery = (scope) => (scope === "system" ? "?scope=system" : "");

const getDocumentTypes = (scope) => {
  return axios.get(API_URL + "document-types" + _docScopeQuery(scope), { headers: authHeader() });
};

const getDocumentTypeById = (id, scope) => {
  return axios.get(API_URL + `document-types/${id}` + _docScopeQuery(scope), { headers: authHeader() });
};

const createDocumentType = (data) => {
  return axios.post(API_URL + "document-types", data, { headers: authHeader() });
};

const updateDocumentType = (id, data, scope) => {
  return axios.put(API_URL + `document-types/${id}` + _docScopeQuery(scope), data, { headers: authHeader() });
};

const deleteDocumentType = (id, scope) => {
  return axios.delete(API_URL + `document-types/${id}` + _docScopeQuery(scope), { headers: authHeader() });
};
// +++ ENDE: API-FUNKTIONEN FÜR BELEGARTEN +++

// --- Formular-Vorlagen-System (Phase 4) ---
// Resolve: liefert die fuer die Stufe fertig aufgeloeste Feldliste.
const resolveFormTemplate = (templateKey, tier) => {
  return axios.get(API_URL + "form-templates/resolve/" + encodeURIComponent(templateKey), {
    headers: authHeader(),
    params: tier ? { tier } : {},
  });
};

// Admin: Registry-Metadaten (erlaubte Typen + Felder + Stufen).
const getFormTemplateRegistry = () => {
  return axios.get(API_URL + "form-templates/registry", { headers: authHeader() });
};

// Admin: Vorlagen-Verwaltung.
const getFormTemplates = (withFields) => {
  return axios.get(API_URL + "form-templates", {
    headers: authHeader(),
    params: withFields ? { withFields: 1 } : {},
  });
};

const getFormTemplate = (id) => {
  return axios.get(API_URL + "form-templates/" + id, { headers: authHeader() });
};

const createFormTemplate = (data) => {
  return axios.post(API_URL + "form-templates", data, { headers: authHeader() });
};

const updateFormTemplate = (id, data) => {
  return axios.put(API_URL + "form-templates/" + id, data, { headers: authHeader() });
};

const deleteFormTemplate = (id) => {
  return axios.delete(API_URL + "form-templates/" + id, { headers: authHeader() });
};

const addFormField = (templateId, data) => {
  return axios.post(API_URL + "form-templates/" + templateId + "/fields", data, { headers: authHeader() });
};

const updateFormField = (fieldId, data) => {
  return axios.put(API_URL + "form-fields/" + fieldId, data, { headers: authHeader() });
};

const deleteFormField = (fieldId) => {
  return axios.delete(API_URL + "form-fields/" + fieldId, { headers: authHeader() });
};

const upsertFormOverride = (templateId, data) => {
  return axios.put(API_URL + "form-templates/" + templateId + "/overrides", data, { headers: authHeader() });
};

const deleteFormOverride = (overrideId) => {
  return axios.delete(API_URL + "form-overrides/" + overrideId, { headers: authHeader() });
};

// +++ ANFANG: MEIN KONTO / DASHBOARD (Folgeprompt 15) +++
// Eigenes Passwort aendern (stufenuebergreifend, OWASP: aktuelles PW erforderlich).
const changeMyAccountPassword = (payload) => {
  return axios.put(API_URL + "account/password", payload, { headers: authHeader() });
};

// Rollen-/stufengescopte Dashboard-Kennzahlen laden.
const getMyAccountStats = () => {
  return axios.get(API_URL + "account/stats", { headers: authHeader() });
};

// SSO-Token fuer qr.myn.club anfordern (Backend: POST /api/sso/qr-token).
// Die Basis wird aus API_URL (".../api/test/") abgeleitet, da SSO unter
// "/api/sso/" liegt. Kein Hardcoding der Origin.
const issueQrSsoToken = () => {
  const ssoUrl = API_URL.replace(/\/api\/test\/?$/, "") + "/api/sso/qr-token";
  return axios.post(ssoUrl, {}, { headers: authHeader() });
};
// +++ ENDE: MEIN KONTO / DASHBOARD +++

const userService = {
  // Mein Konto / Dashboard (Folgeprompt 15)
  changeMyAccountPassword,
  getMyAccountStats,
  issueQrSsoToken,

  // Formular-Vorlagen-System
  resolveFormTemplate,
  getFormTemplateRegistry,
  getFormTemplates,
  getFormTemplate,
  createFormTemplate,
  updateFormTemplate,
  deleteFormTemplate,
  addFormField,
  updateFormField,
  deleteFormField,
  upsertFormOverride,
  deleteFormOverride,

  // Oben eingefügte Funktionen hier exportieren
  getPaymentMethods,
  getPaymentMethodsForAdm, // <-- HIER HINZUGEFÜGT/KORRIGIERT
  getPaymentMethodById,
  createPaymentMethod,
  updatePaymentMethodStatus,
  updatePaymentMethod,
  createPaymentSession,
  createPaymentLink, // <-- HIER DIE NEUE FUNKTION HINZUFÜGEN
  getOrderStatus, // <-- HIER HINZUFÜGEN

  getMainVoById,
  getSubVoById,
  getAdmById,
  cancelDemoBatchCode,
  saveBatchCode,
  getMyEmployees,
  getAllBatchCodes,
  getUpgradeOffers,
  manageCustomerSubscription,
  bookCustomerOffer,
  getAllAds,
  getAdById,
  createAd,
  updateAd,
  deleteAd,
  getCustomerEmployeesBoard,
  getCustomerMeBoard,
  getPublicContent,
  getUserBoard,
  getModeratorBoard,
  getAdminBoard,
  getTaxesBoard,
  deleteTaxesBoard,
  updateTaxesBoard,
  createTaxesBoard,
  getMainVosBoard,
  deleteMainVosBoard,
  updateMainVosBoard,
  createMainVosBoard,
  getEmployiesBoard,
  deleteEmployiesBoard,
  updateEmployiesBoard,
  createEmployiesBoard,
  getSubVosBoard,
  deleteSubVosBoard,
  updateSubVosBoard,
  createSubVosBoard,
  getCustomerBoard,
  deleteCustomerBoard,
  updateCustomerBoard,
  createCustomerBoard,
  getAreaGroupBoard,
  deleteAreaGroupBoard,
  updateAreaGroupBoard,
  createAreaGroupBoard,
  getAreaBoard,
  getAreaBoard2,
  deleteAreaBoard,
  updateAreaBoard,
  createAreaBoard,
  getCountryBoard,
  deleteCountryBoard,
  updateCountryBoard,
  createCountryBoard,
  getCurrencyBoard,
  deleteCurrencyBoard,
  updateCurrencyBoard,
  createCurrencyBoard,
  getServiceBoard,
  deleteServiceBoard,
  updateServiceBoard,
  createServiceBoard,
  getShowcaseBoard,
  createShowcase,
  updateShowcase,
  deleteShowcase,
  getApiRegistry,
  createApiRegistry,
  updateApiRegistry,
  deleteApiRegistry,
  testApiRegistry,
  getApiParameters,
  getStatusBoard,
  deleteStatusBoard,
  updateStatusBoard,
  createStatusBoard,
  getSelfServiceOffer,
  getSelfServiceMapEntries,
  getSelfServiceCatalog,
  getSelfServiceAltchaChallenge,
  get2faStatus,
  setup2fa,
  confirm2fa,
  disable2fa,
  requestPasswordReset,
  setPasswordWithToken,
  registerSelfService,
  createSelfServiceTrial,
  getSelfServiceLive,
  getSelfServiceMapFlights,
  confirmSelfServiceEmail,
  resendSelfServiceConfirmation,
  getSelfServiceProfile,
  updateSelfServiceProfile,
  getPublicBusinessDetail,
  getPromo,
  updatePromo,
  uploadPromoFlyer,
  deletePromoFlyer,
  getTransportTypesBoard,
  deleteTransportTypeBoard,
  updateTransportTypeBoard,
  createTransportTypeBoard,
  getStartCreditTypesBoard,
  deleteStartCreditTypeBoard,
  updateStartCreditTypeBoard,
  createStartCreditTypeBoard,
  getPlacesBoard,
  deletePlacesBoard,
  updatePlacesBoard,
  createPlacesBoard,
  getTariffBoard,
  getParentTariffTemplates,
  getTariffById, 
  deleteTariffBoard,
  updateTariffBoard,
  createTariffBoard,
  getQutelMasterdata,
  getRolesBoard,
  deleteRolesBoard,
  updateRolesBoard,
  createRolesBoard,
  getUsersBoard,
  deleteUsersBoard,
  updateUsersBoard,
  createUsersBoard,
  setUserLock,
  getBatchBoard,
  deleteBatchBoard,
  bulkBatchAction,
  updateBatchBoard,
  createBatchBoard,
  getDashboard,
  getPlacesBoardWB,
  getNotificationBoard,
  deleteNotificationBoard,
  updateNotificationBoard,
  createNotificationBoard,
  sendNotificationBoard,
  getRequestData,
  deleteRequestData,
  updateRequestData,
  createRequestData,
  changeMyPasswordBoard,
  getSingleEmployeeBoard,
  changeMyPasswordEmployeeBoard,
  employeeRequestData,
  customerRequestData,
  customerERequestData,
  getBatchBoardMaster,
  deleteBatchBoardMaster,
  updateBatchBoardMaster,
  toggleBatchLock,
  createBatchBoardMaster,
  createInvoice,
  getInvoices,
  cancelInvoice,
  markInvoiceAsPaid,
  downloadInvoice,
  generateInvoicePdf,
  deleteInvoice,
  getAllCountries,
  getCountryById,
  createCountry,
  updateCountry,
  deleteCountry,
  getAllTaxes,
  getAllCurrencies,
  getBatchBoardSubvos,
  rentBatchPortion,
  getBatchOrders,
  getBatchOrderByBatchId, 
  revertRenting,
  getADMBatchOrders,
  getCustomersADM,
  getAllCustomersADMP,
  sellBatchCodes,
  getBatchOrdersADM,
  cancelBatchOrders,
  getInvoicesADM,
  downloadInvoiceADM,
  getIncomingInvoicesForSubvo,
  downloadIncomingInvoiceForSubvo,
  getTariffBoardADM,
  getAdByIdADM,
  updateAdBoard,
  changeMyPasswordBoardADM,
  getDemoBatchOrders,
  lookupDemoCode,
  activateDemoBatchCodes,
  updateTargetPlace,
  sendNotificationBoardReset,
  getCustomerReviews,
  getEmployeeReviews,
  getInvoicesCustomer,
  downloadInvoiceCustomer,
  sellDemoBatchCodes,
  getInvoicesSUBVO,
  getInvoiceNumberSettings,
  updateInvoiceNumberSettings,
  downloadInvoiceSUBVO,

  // Fügen Sie die neuen Funktionen hier ein
  getDocumentTypes,
  getDocumentTypeById,
  createDocumentType,
  updateDocumentType,
  deleteDocumentType,

  // === NEUE FUNKTIONEN FÜR PASSWORT-RESET ===

  resetMainVoPassword(id) {
    return axios.post(API_URL + `mainvos/${id}/reset-password`, {}, { headers: authHeader() });
  },

  resetSubVoPassword(id) {
    return axios.post(API_URL + `subvos/${id}/reset-password`, {}, { headers: authHeader() });
  },

  resetAdmPassword(id) {
    return axios.post(API_URL + `ads/${id}/reset-password`, {}, { headers: authHeader() });
  },

  resetCustomerPassword(id, payload = {}) {
    return axios.post(API_URL + `customers/${id}/reset-password`, payload, { headers: authHeader() });
  },

  resetUserPassword(id) {
    return axios.post(API_URL + `users/${id}/reset-password`, {}, { headers: authHeader() });
  },

  getBatchesForSubVoBoard(data) {
    return axios.post(API_URL + "subvo/batches", data, { headers: authHeader() });
  },

  getAllRentedBatches(data) {
    return axios.post(API_URL + "rented-batches", data, { headers: authHeader() });
  },

  getBatchNames() {
    return axios.get(API_URL + "batch-names", { headers: authHeader() });
  },
  
};



export default userService